import { render, staticRenderFns } from "./GPTAssistants.vue?vue&type=template&id=a56f5304&scoped=true"
import script from "./GPTAssistants.vue?vue&type=script&lang=js"
export * from "./GPTAssistants.vue?vue&type=script&lang=js"
import style0 from "./GPTAssistants.vue?vue&type=style&index=0&id=a56f5304&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a56f5304",
  null
  
)

export default component.exports